import React, { useEffect, useRef } from "react";

export const MouseEffect = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    
    const ctx = canvas.getContext("2d");
    let particlesArray = [];

    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;

    window.addEventListener("resize", () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    });

    const mouse = {
      x: undefined,
      y: undefined,
    };

    window.addEventListener("mousemove", (event) => {
      mouse.x = event.x;
      mouse.y = event.y;
      particlesArray.push(new Particle());
    });

    class Particle {
      constructor() {
        this.x = mouse.x;
        this.y = mouse.y;
        this.size = Math.random() * 4 + 1;
        this.speedX = Math.random() * 1.5 - 0.75; 
        this.speedY = Math.random() * 1.5 - 0.75; 
        // GÜNCELLENDİ: OmemTech Siber Turuncu Rengi
        this.color = "#e5882a";
      }
      
      update() {
        this.x += this.speedX;
        this.y += this.speedY;
        if (this.size > 0.2) this.size -= 0.05;
      }
      
      draw() {
        ctx.fillStyle = this.color;
        ctx.beginPath();
        ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
        ctx.fill();
      }
    }

    function handleParticles() {
      for (let i = 0; i < particlesArray.length; i++) {
        particlesArray[i].update();
        particlesArray[i].draw();
        
        if (particlesArray[i].size <= 0.2) {
          particlesArray.splice(i, 1);
          i--;
        }
      }
    }

    function animate() {
      // Trail (iz) efekti için ekranı temizleme rengini ayarlıyoruz.
      // Arka plan rengine göre bir şeffaflık tonu vermek daha iyi iz bırakır.
      ctx.fillStyle = "rgba(23, 23, 23, 0.2)"; 
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      
      handleParticles();
      requestAnimationFrame(animate);
    }
    
    animate();

  }, []);

  return (
    <canvas
      ref={canvasRef}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        pointerEvents: "none", 
        zIndex: 9999, 
      }}
    />
  );
};